function getLargeViewportOrientation(viewportOrientation, imageOrientation) {
  if (!viewportOrientation || !imageOrientation) {
    return "column";
  }
  if (viewportOrientation === "vertical") {
    return "column";
  } else if (viewportOrientation === "horizontal") {
    if (imageOrientation === "left") {
      return "row";
    } else if (imageOrientation === "right") {
      return "row-reverse";
    }
  }
  return "column";
}
function getAnalyticsData(data) {
  if (!data) return;
  const title = getAnalyticsTitle(data);
  const url = getURL(data);
  return { title, url };
}
function getAnalyticsTitle(data) {
  const { text_content, feature_tiles } = data;
  if (text_content) {
    for (const text of text_content) {
      if (text.select_text_type === "title") return text.markdown_text;
    }
  }
  if (feature_tiles && feature_tiles.length > 0) {
    return feature_tiles[0].title;
  }
  return "";
}
function getURL(data) {
  var _a, _b;
  const { button_config } = data.below_feature_tiles;
  if ((_a = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _a.url)
    return (_b = button_config == null ? void 0 : button_config.text_and_url) == null ? void 0 : _b.url;
}
function createButtonRow(array, sliceFunc) {
  const out = [];
  for (let i = 0; i < array.length; i += 2) {
    const slice = array.slice(i, i + 2);
    out.push(sliceFunc(slice, i));
  }
  return out;
}
const getExternalLinkProps = (externalLinkTranslations) => {
  const {
    titleContent,
    bodyContent,
    primaryButtonContent,
    secondaryButtonContent,
    closeButtonAriaLabel
  } = externalLinkTranslations;
  const warningTitle = titleContent;
  const warningText = bodyContent;
  const warningPrimaryButtonText = primaryButtonContent;
  const warningSecondaryButtonText = secondaryButtonContent;
  const warningCloseAriaLabel = closeButtonAriaLabel;
  return {
    warningCloseAriaLabel,
    warningPrimaryButtonText,
    warningSecondaryButtonText,
    warningText,
    warningTitle
  };
};
export {
  createButtonRow,
  getAnalyticsData,
  getExternalLinkProps,
  getLargeViewportOrientation
};
